
import React, { useState } from 'react'
import GenericTable from './UI/reusable-components/GenericTable';
import Invoice from './UI/reusable-components/Invoice'
import { useDispatch, useSelector } from 'react-redux';
import { fetchInvoice } from '../redux/actions/InvoicesActions';

export const Invoices = ({ invoices, totalInvoices = 0,setSelectedInvoices,selectedInvoices }) => {
  const headers = ['Sipariş No#', 'Belge No#', 'Fatura Tarihi', 'Müşteri Bilgileri', 'Satış Kanalı', 'Fatura Tutarı', 'Birim','Durum','Fatura', 'İşlem'];
  const [isLoading, setIsLoading] = useState(false);
  // const filterFields = [
  //   { label: "Sipariş No", name: "invoiceNumber", type: "text" },

  //   { name: "createTime", type: "date" },
  //   { label: "Belge No", name: "documentNumber", type: "text" },
  //   { label: "TCKN veya VKN", name: "tckn", type: "text" },
  //   { label: "Müşteri Adı", name: "name", type: "text" },
  // ];


  const [filterFields, setFilterFields] = useState([
    { label: "Sipariş No", name: "orderNumber", type: "text", value: null },
    {
      name: "dateRange",
      type: "dateRange",
      startName: "startDate",
      endName: "endDate",
      value: { startDate: null, endDate: null }
    },
    { label: "Belge No", name: "number", type: "text", value: null },
    { label: "TCKN veya VKN", name: "identifier", type: "text", value: null },
    { label: "Müşteri Adı", name: "customerFirstName", type: "text", value: null },
  ]);

  const comboBoxFilterFields = [
    // { label: "Tüm Mağazalar", name: "store", options: [] },
    // { label: "Satış Kanalı", name: "salesChannel", options: [] },
    // { label: "Kargolar", name: "cargo", options: CARGO_COMPANIES },
  ]


  const rangeInputFilterFields = [
    // { label: "Min. Sipariş Miktarı", name: "priceRangeStart" },
    // { label: "Max. Sipariş Miktarı", name: "priceRangeEnd" },
  ]
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filtersValue, setFiltersValue] = useState({});
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const [comboBoxFilter, setComboBoxFilter] = useState(null);
  const dispatch = useDispatch();
  const handlePageChange = async (newPage) => {
    try {

      setIsLoading(true);
      const maxPage = Math.ceil(totalInvoices / pageSize);
      if (newPage >= 1 && newPage <= maxPage) {
        setCurrentPage(newPage);
        await dispatch(fetchInvoice(
          authUserId,
          newPage,
          pageSize
        ));
      }
    } catch (error) {
      console.error('Sayfa değişimi sırasında hata:', error);
      setCurrentPage(currentPage);
    } finally {
      setIsLoading(false);
    }
  };
  const handlePageSizeChange = async (newPageSize) => {
    try {
      setIsLoading(true);
      if (newPageSize > 0) {
        setPageSize(newPageSize);
        setCurrentPage(1);
        await dispatch(fetchInvoice(
          authUserId,
          currentPage,
          newPageSize
        ));
      }
    } catch (error) {
      console.error('Sayfa boyutu değişimi sırasında hata:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Handler fonksiyonları
  const handleOnSearchFilters = async (filters) => {
    try {
      console.log('Filtreler:', filters);
      setIsLoading(true);
      await dispatch(fetchInvoice(
        authUserId,
        1,
        pageSize,
        filters));
    } catch (error) {
      console.error('Filtreleme sırasında hata:', error);
    } finally {
      setIsLoading(false);
    }
  };



  // ürün stok kodu eklenecek
  const filters = {
    invoiceNumber: '',
    createTime: '',
    taxNumber: '',
    customerName: '',
    documentNumber: '',
    store: '',
    salesChannel: '',
    cargo: '',
    priceRange: [0, 0],
    tckn: null
  }
  const filterLogic = (invoice, filters) => {
    const invoiceDate = new Date(invoice.createTime).toLocaleDateString()
    const filterDate = new Date(filters.createTime).toLocaleDateString();

    return (
      (filters.invoiceNumber ? invoice.order?.orderNumber.toString().includes(filters.invoiceNumber) : true) &&
      (filters.createTime ? invoiceDate === filterDate : true) &&
      (filters.documentNumber ? invoice.number.toString().includes(filters.documentNumber) : true) &&
      (filters.tckn ? (invoice?.userOfCustomer?.identityNumber && invoice?.userOfCustomer?.identityNumber.toString().trim().includes(filters.tckn)) : true) &&
      (filters.customerName ? `${(invoice?.invoiceRecordType === 1 ? invoice?.userOfCustomer?.title : invoice?.order?.customerFirstName + invoice?.order?.customerLastName).toLowerCase()}`.includes(filters.customerName.toLowerCase()) : true) &&
      (filters.cargo ? (invoice.cargoProviderName && invoice.cargoProviderName.toLowerCase()) : true) &&
      ((filters.priceRange[0] === 0 && filters.priceRange[1] === 0) || (invoice.totalPrice >= filters.priceRange[0] && invoice.totalPrice <= filters.priceRange[1]))
    );
  };

  const fieldsToClear = {
    invoiceNumber: '',
    createTime: '',
    taxNumber: '',
    customerName: '',
    documentNumber: '',
    store: '',
    salesChannel: '',
    cargo: '',
    priceRange: [0, 0],
    tckn: ''
  }

  return (
    <GenericTable
      data={invoices}
      headers={headers}
      filterFields={filterFields}
      setFilterFields={setFilterFields}
      setComboBoxFilter={setComboBoxFilter}
      filterLogic={(_invoice) => true}
      RowComponent={Invoice}
      filters={filters}
      comboBoxFilterFields={comboBoxFilterFields}
      fieldsToClear={fieldsToClear}
      rangeInputFilterFields={rangeInputFilterFields}
      currentPage={currentPage}
      setCurrentPage={handlePageChange}
      totalItems={Number(totalInvoices) || 0}
      pageSize={pageSize}
      setPageSize={handlePageSizeChange}
      setFiltersValue={setFiltersValue}
      onSearchFilters={handleOnSearchFilters}
      isLoading={isLoading}
      setSelectedData={setSelectedInvoices}
      selectedData={selectedInvoices}
    />
  );

}